export default __webpack_public_path__ + "static/media/fv_production.104fecad.svg";